import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';
import { BlocksIconTriangleFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/triangle-filled';

export const CatIconTriangleFilled = createComponent({
  react: React,
  tagName: 'cat-icon-triangle-filled',
  elementClass: BlocksIconTriangleFilled
});
